import { FC, memo, ReactNode } from 'react';

interface DropzoneContentProps {
  isPreview: boolean;
  title: string;
  icon?: ReactNode;
  renderDropzoneBody: () => ReactNode;
}

interface DashedFieldProps {
  title: string;
  width?: string;
  height?: string;
}

const DashedField: FC<DashedFieldProps> = ({
  title,
  width = '341px',
  height = '74px',
}) => (
  <div
    className={`border-2 border-dashed border-tpg_base rounded-lg flex items-center justify-center transition-all mx-auto`}
    style={{ width, height }}
  >
    <span className="text-center uppercase text-tpg_base">{title}</span>
  </div>
);

const DropzoneContent: FC<DropzoneContentProps> = ({
  isPreview,
  title,
  icon,
  renderDropzoneBody,
}) =>
  isPreview ? (
    <div className="flex flex-col h-full">
      <div className="flex justify-between w-full mb-2">
        {renderDropzoneBody()}
        {icon}
      </div>
      <div className="mt-auto">
        <DashedField title={title} />
      </div>
    </div>
  ) : (
    <div className="flex flex-col items-center justify-center h-full gap-2">
      {icon}
      <DashedField title={title} />
    </div>
  );

export default memo(DropzoneContent);
